//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import getFrameTypes from '~/constants/frameTypes'

export default {
  props: {
    design: { type: Object, required: true },
    secondaryDesign: { type: Object, required: true },
    baseSku: { type: String, required: true },
    frameType: { type: String, required: true },
    expanded: { type: Boolean, default: false },
    conversionKitEnabled: { type: Boolean, required: true },
    hideConversionKit: { type: Boolean, required: true }
  },
  computed: {
    ...mapGetters({
      getPriceFromSku: 'product/priceFromSku'
    }),
    options () {
      return getFrameTypes(this.baseSku)
    },
    activeOption () {
      return this.options.find(this.testIsActiveOption)
    },
    optionsWithDetails () {
      // Get altered SKU for each option
      return this.options.map((option) => {
        return {
          ...option,
          active: false,
          price: this.getPrice(option)
        }
      }).filter(option => !option.conversionKit || !this.hideConversionKit)
    },
    classes () {
      return {
        FrameTypeSelect: true,
        'FrameTypeSelect--expanded': this.expanded,
        'FrameTypeSelect--reduced-options': this.optionsWithDetails.length < 4
      }
    },
    combinedDesign () {
      return {
        ...this.design,
        ...this.secondaryDesign
      }
    },
    basePrice () {
      const parts = Object.entries(this.combinedDesign).filter(
        ([part, _]) => !this.allParts.includes(part)
      ).map(
        ([part, choice]) => `${part}_${choice}`
      )

      const sku = [this.baseSku, ...parts].join('-')

      return this.getPriceFromSku(sku)
    },
    allParts () {
      return this.options.map(option => option.parts || []).flat()
    }
  },
  methods: {
    change (option) {
      if (option.disabled) return
      if (option.conversionKit) {
        if (this.conversionKitEnabled && !this.expanded) {
          const newFrameType = ['vulcans', 'velans'].includes(this.baseSku)
            ? (this.frameType === 'ff' ? 'tf' : 'ff')
            : (this.frameType === 'bf' ? 'fl' : 'bf')
          return this.$emit('change-frame-type', newFrameType)
        }
        return this.$emit('toggle-conversion-kit', true)
      } else {
        this.$emit('change-frame-type', option.frameType)
        this.$emit('toggle-conversion-kit', false)
      }
    },
    testIsActiveOption (option) {
      if (this.conversionKitEnabled) return !!option.conversionKit
      return option.frameType === this.frameType
    },
    getPrice (option) {
      const parts = Object.entries(this.combinedDesign).filter(
        ([part, choice]) => (option.conversionKit ? this.allParts : option.parts).includes(part)
      ).map(
        ([part, choice]) => `${part}_${choice}`
      )

      const sku = [this.baseSku, ...parts].join('-')
      return this.basePrice + this.getPriceFromSku(sku)
    }
  }
}
